/* ==========================================================================
   pd-data.js — overlays live Shopify commerce data onto window.PRODUCTS.

   Must load AFTER data-products.js and BEFORE fable5-page(s).js, because
   fable5-pages.js captures `window.PRODUCTS` when its IIFE runs.

   Curated editorial fields (category, bestseller, tag, desc, img) stay exactly
   as authored in data-products.js. Only commerce facts come from Shopify:
   price, variant ids, and availability. The shape of window.PRODUCTS is
   unchanged, so every render path keeps working untouched.
   ========================================================================== */
(function () {
  'use strict';

  var LIVE = window.PD_LIVE;
  var PRODUCTS = window.PRODUCTS;

  if (!LIVE || !PRODUCTS || !PRODUCTS.length) return;

  var seen = {};

  PRODUCTS.forEach(function (p) {
    var live = LIVE[p.handle];
    if (!live) {
      // In the curated file but not in Shopify (unpublished / deleted).
      // Flag it so the grid can hide it rather than offering a dead add-to-cart.
      p.unavailable = true;
      return;
    }
    seen[p.handle] = true;

    p.id = live.id;
    p.url = live.url;
    p.available = live.available;
    p.from = live.from;

    /* Shopify's product photo is authoritative for cards and the PDP hero
       slide. The curated still is kept only as a fallback for a product with
       no image uploaded, so a card can never render empty. */
    if (live.image) p.img = live.image;

    // Variants carry no editorial content, so Shopify is authoritative.
    // Keeping the {strength, pack, price} shape the front-end already renders.
    if (live.variants && live.variants.length) {
      p.variants = live.variants.map(function (v) {
        return {
          id: v.id,
          strength: v.strength,
          pack: v.pack,
          price: v.price,
          available: v.available
        };
      });
      // strengths[] drives the PDP dosage selector — rebuild from live options
      var st = [];
      p.variants.forEach(function (v) {
        if (v.strength && st.indexOf(v.strength) < 0) st.push(v.strength);
      });
      if (st.length) p.strengths = st;
    }
  });

  // Products added in Shopify after the curated file was written. Appended with
  // safe fallbacks so the catalogue never silently omits something for sale.
  Object.keys(LIVE).forEach(function (handle) {
    if (seen[handle]) return;
    var live = LIVE[handle];
    var strengths = [];
    (live.variants || []).forEach(function (v) {
      if (v.strength && strengths.indexOf(v.strength) < 0) strengths.push(v.strength);
    });
    PRODUCTS.push({
      handle: handle,
      title: live.title,
      from: live.from,
      strengths: strengths,
      category: 'Research Peptides',
      bestseller: false,
      img: live.image || '',
      tag: '',
      desc: '',
      id: live.id,
      url: live.url,
      available: live.available,
      variants: (live.variants || []).map(function (v) {
        return {
          id: v.id, strength: v.strength, pack: v.pack,
          price: v.price, available: v.available
        };
      })
    });
  });

  // Drop anything no longer purchasable so no dead card can reach the cart.
  window.PRODUCTS = PRODUCTS.filter(function (p) { return !p.unavailable; });
}());
